import { Secondary } from "../../foundations/palette.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
const DASH_DOT_WIDTH = 0.625;
const DASH_DOT_HEIGHT = 0.66875;
const linearProgressStylesOverride = {
  root: {
    height: Spacing["500"]
  },
  dashed: {
    backgroundSize: `${DASH_DOT_WIDTH}rem ${DASH_DOT_HEIGHT}rem`
  },
  colorSecondary: {
    background: Secondary.light
  }
};
export {
  linearProgressStylesOverride
};
//# sourceMappingURL=styles.es.js.map
